import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IUser } from "../iUser";
import { UserEditorViewModel, UserInserter } from "../userEditor/userEditor-viewModel";
import  { UserManipulationView } from "./userManipulation-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class UserManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'نعریف کاربر';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.users = ObservableArray.create<user>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()

    }
    GetDefaultView(): View <ViewModel> {
        return new UserManipulationView();
    }
    public getTypeId(): string {
        return "VM-EDD89E2D-5ED5-4F67-A510-DA7069D6FE09"
    }

    public set users(v: ObservableArray<user>) { this._users = v; } public get users(): ObservableArray<user> { return this._users;} private _users: ObservableArray<user>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/GetAllUsers',{
                FurtherQueryInfo:filteringInformation
            });
            this.users.update(...result.Users.map(q=>{
                let r = new user(this);
                r.id = q.Id;
                r.username = q.Username;
                r.personnelId = q.PersonnelId;
                r.personnelCode = q.PersonnelCode;
                r.personnelFullName = stringIsNullOrEmpty(r.personnelId) ? "" : `${q.PersonnelName} ${q.PersonnelLastName}`;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new UserEditorViewModel(this,new UserInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    
    async edit(personnel:user){
        let popup = new PersonnelPasswordEditorViewModel(this);
        popup.cloneTo(personnel);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
}
export class user extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:UserManipulationViewModel) {
        super(parent);

        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    public set personnelCode(v:string) {this._personnelCode = v; } public get personnelCode(): string {return this._personnelCode;} private _personnelCode:string;    
    
    private _typedParent : UserManipulationViewModel;

    getPassword(): string {
        throw new Error("Method not implemented.");
    }

    edit(){
        this._typedParent.edit(this);
    }
}

export class PersonnelPasswordEditorViewModel extends ViewModel implements IPopup{
    public getTypeId(): string {return 'changepassword';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

    }

    closePopup(result: any) {
    }
    cloneTo(user: user) {
        this.id = user.id;
        this.personnelId = user.personnelId;
        this.username = user.username;
        this.personnelFullName = user.personnelFullName;
        this.personnelCode = user.personnelCode;
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set personnelCode(v:string) {this._personnelCode = v; } public get personnelCode(): string {return this._personnelCode;} private _personnelCode:string;    
    
    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در تغییر رمز عبور');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/ChangePersonnelPassword',{
                    UserId :this.id,
                    Password:this.password
                });
                if(result.IsSuccessful==false){
                    throw "Error Saving Personnel";
                }
                await this.messageBoxConfirmSuccess('پرسنل با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت پرسنل','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify():string[]{
        let result :string[] = [];
        
        if(stringIsNullOrEmpty(this.password)){
            result.push('پسورد خالی است.')
        }
        return result;
    }

}

